module.exports = __webpack_public_path__ + "static/img/icon-5.4f9bd6cd.png";